import BaseModalStore from '@src/components/modal-container/base-modal-store';
import redirectToMiniprogram from '@src/utils/h5-redirect-to-miniprogram';
import { MINI_PROGRAM_CONFIG } from '@src/constants/business';

class AppointmentSuccessModalStore extends BaseModalStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  appointmentByMiniprogram = () => {
    redirectToMiniprogram({ ...MINI_PROGRAM_CONFIG });
  };

  use() {
    super.use();
  }
}

export default AppointmentSuccessModalStore;
